const ICON_MAPPINGS = {
  FINSPEAKER: {icon: 'icon-information', title: 'finSpeaker'},
  FINHUB: { icon: 'icon-myfinhub', title: 'finHub' },
  FINNEWS: { icon: 'icon-news', title: 'finNews' },
  FINTOOLS: { icon: 'icon-tools', title: 'finTools' },
  FINSTRATEGY: { icon: 'icon-strategy', title: 'finStrategy' },
  FINCOMMUNITY: { icon: 'icon-community', title: 'finCommunity' },
  FINACADEMY: {icon: 'icon-academy', title: 'finAcademy'},
  /* Alerts: wenn ein Wertpapier über eine Watchlist überwacht wird und die Limits überschritten werden */
  FINALERT: {icon: 'icon-eye', title: 'finAlert'},
  /* Handlungsbedarf Nachrichten: wenn ein Wertpapier nicht mehr in einer Strategie passt */
  FINNEEDFORACTION: {icon: 'icon-notification', title: 'finHandlungsbedarf'}
}

const dropDownValues = Object.entries(ICON_MAPPINGS).map(([key, val]) => {
  return { text: val.title, value: key }
})

export default {
  dropDownValues,

  messageIcon (type) {
    return ICON_MAPPINGS[type].icon
  }
}
